import { numberFormatter } from '@h20-shared/utils/number-format-utils';
import type { AggregateValue } from './dashboard-aggregate';

export const DASHBOARD_VALUE_FORMATS = ['integer', 'decimal', 'percent'] as const;
export type DashboardValueFormat = (typeof DASHBOARD_VALUE_FORMATS)[number];

/** How many decimals a `decimal` or `percent` value shows. */
export const DASHBOARD_DECIMAL_PLACES = 2;

export const DASHBOARD_VALUE_FORMAT_OPTIONS: Readonly<
    Record<DashboardValueFormat, Intl.NumberFormatOptions>
> = {
    integer: { maximumFractionDigits: 0 },
    decimal: {
        minimumFractionDigits: DASHBOARD_DECIMAL_PLACES,
        maximumFractionDigits: DASHBOARD_DECIMAL_PLACES,
    },
    percent: {
        style: 'percent',
        minimumFractionDigits: DASHBOARD_DECIMAL_PLACES,
        maximumFractionDigits: DASHBOARD_DECIMAL_PLACES,
    },
};

export function ratioValueFormat(format: DashboardValueFormat): DashboardValueFormat {
    return format === 'integer' ? 'decimal' : format;
}

/** The value as text in the reader's language. Text passes through; `percent` expects a fraction. */
export function formatDashboardValue(
    value: AggregateValue,
    format: DashboardValueFormat,
    locale: string
): string | undefined {
    if (value === undefined) {
        return undefined;
    }
    if (typeof value === 'string') {
        return value;
    }

    return numberFormatter(locale, DASHBOARD_VALUE_FORMAT_OPTIONS[format]).format(value);
}
